"use client";

import React from "react";
import { ArrowDown } from "../../../ui/Form/Select/select";
import Link from "next/link";
export const InputBtn: React.FC<{ placeholder: string; isActive: boolean }> = ({
  placeholder,
  isActive,
  ...props
}) => {
  return (
    <div
      className={`flex border justify-between h-full gap-3 rounded-md min-w-[100px] ${
        !isActive ? "border-label-main" : "border-themeColor"
      } items-center p-3`}
      {...props}
    >
      <span className="text-sm whitespace-nowrap">{placeholder}</span>
      <span
        className={`transition-all duration-500 ${
          !isActive ? "rotate-0" : "rotate-[180deg]"
        }`}
      >
        <ArrowDown />
      </span>
    </div>
  );
};

export const Logo: React.FC<{ height?: string; width?: string }> = ({
  height,
  width,
}) => (
  <Link href="/">
    <svg
      width={width || "168"}
      height={height || "43"}
      viewBox="0 0 168 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="21.2132"
        width="30"
        height="30"
        transform="rotate(-45 0 21.2132)"
        fill="var(--primary-color)"
      />
      <path
        d="M50.9901 12.2586H54.5611L58.831 19.9802H59.0014L63.2713 12.2586H66.8424L60.4929 23.2018V29.7132H57.3395V23.2018L50.9901 12.2586ZM72.2181 29.9689C70.9397 29.9689 69.8317 29.6876 68.8942 29.1251C67.9567 28.5626 67.2294 27.7757 66.7124 26.7643C66.201 25.753 65.9453 24.5712 65.9453 23.2189C65.9453 21.8666 66.201 20.6819 66.7124 19.6649C67.2294 18.6479 67.9567 17.8581 68.8942 17.2956C69.8317 16.7331 70.9397 16.4518 72.2181 16.4518C73.4965 16.4518 74.6044 16.7331 75.5419 17.2956C76.4794 17.8581 77.2039 18.6479 77.7152 19.6649C78.2323 20.6819 78.4908 21.8666 78.4908 23.2189C78.4908 24.5712 78.2323 25.753 77.7152 26.7643C77.2039 27.7757 76.4794 28.5626 75.5419 29.1251C74.6044 29.6876 73.4965 29.9689 72.2181 29.9689ZM72.2351 27.4973C72.9283 27.4973 73.5078 27.3069 73.9737 26.9263C74.4397 26.5399 74.7862 26.0229 75.0135 25.3751C75.2465 24.7274 75.3629 24.0058 75.3629 23.2104C75.3629 22.4092 75.2465 21.6848 75.0135 21.0371C74.7862 20.3837 74.4397 19.8638 73.9737 19.4774C73.5078 19.091 72.9283 18.8979 72.2351 18.8979C71.5249 18.8979 70.934 19.091 70.4624 19.4774C69.9965 19.8638 69.647 20.3837 69.4141 21.0371C69.1868 21.6848 69.0732 22.4092 69.0732 23.2104C69.0732 24.0058 69.1868 24.7274 69.4141 25.3751C69.647 26.0229 69.9965 26.5399 70.4624 26.9263C70.934 27.3069 71.5249 27.4973 72.2351 27.4973ZM89.4531 24.2075V16.6223H92.5384V29.7132H89.5469V27.3865H89.4105C89.1151 28.1194 88.6293 28.7189 87.9531 29.1848C87.2827 29.6507 86.456 29.8837 85.473 29.8837C84.6151 29.8837 83.8566 29.6933 83.1975 29.3126C82.5441 28.9263 82.0327 28.3666 81.6634 27.6337C81.2941 26.895 81.1094 26.003 81.1094 24.9575V16.6223H84.1946V24.4802C84.1946 25.3098 84.4219 25.9689 84.8764 26.4575C85.331 26.9462 85.9276 27.1905 86.6662 27.1905C87.1208 27.1905 87.5611 27.0797 87.9872 26.8581C88.4134 26.6365 88.7628 26.3069 89.0355 25.8694C89.3139 25.4263 89.4531 24.8723 89.4531 24.2075ZM95.711 29.7132V16.6223H98.7024V18.8041H98.8388C99.0774 18.0484 99.4865 17.466 100.066 17.0569C100.651 16.6422 101.319 16.4348 102.069 16.4348C102.239 16.4348 102.43 16.4433 102.64 16.4604C102.856 16.4717 103.035 16.4916 103.177 16.52V19.3581C103.046 19.3126 102.839 19.2729 102.555 19.2388C102.276 19.199 102.006 19.1791 101.745 19.1791C101.183 19.1791 100.677 19.3013 100.228 19.5456C99.7848 19.7842 99.4354 20.1166 99.1797 20.5427C98.924 20.9689 98.7962 21.4604 98.7962 22.0172V29.7132H95.711ZM111.316 29.7132V12.2586H114.478V27.0626H122.166V29.7132H111.316ZM130.484 29.9689C129.205 29.9689 128.097 29.6876 127.16 29.1251C126.222 28.5626 125.495 27.7757 124.978 26.7643C124.467 25.753 124.211 24.5712 124.211 23.2189C124.211 21.8666 124.467 20.6819 124.978 19.6649C125.495 18.6479 126.222 17.8581 127.16 17.2956C128.097 16.7331 129.205 16.4518 130.484 16.4518C131.762 16.4518 132.87 16.7331 133.808 17.2956C134.745 17.8581 135.469 18.6479 135.981 19.6649C136.498 20.6819 136.756 21.8666 136.756 23.2189C136.756 24.5712 136.498 25.753 135.981 26.7643C135.469 27.7757 134.745 28.5626 133.808 29.1251C132.87 29.6876 131.762 29.9689 130.484 29.9689ZM130.501 27.4973C131.194 27.4973 131.773 27.3069 132.239 26.9263C132.705 26.5399 133.052 26.0229 133.279 25.3751C133.512 24.7274 133.629 24.0058 133.629 23.2104C133.629 22.4092 133.512 21.6848 133.279 21.0371C133.052 20.3837 132.705 19.8638 132.239 19.4774C131.773 19.091 131.194 18.8979 130.501 18.8979C129.791 18.8979 129.2 19.091 128.728 19.4774C128.262 19.8638 127.913 20.3837 127.68 21.0371C127.452 21.6848 127.339 22.4092 127.339 23.2104C127.339 24.0058 127.452 24.7274 127.68 25.3751C127.913 26.0229 128.262 26.5399 128.728 26.9263C129.2 27.3069 129.791 27.4973 130.501 27.4973ZM145.068 34.895C143.96 34.895 143.009 34.7444 142.213 34.4433C141.418 34.1479 140.778 33.7501 140.295 33.2501C139.813 32.7501 139.477 32.1962 139.29 31.5882L142.068 30.9149C142.193 31.1706 142.375 31.4234 142.614 31.6734C142.852 31.9291 143.173 32.1393 143.577 32.3041C143.986 32.4746 144.5 32.5598 145.119 32.5598C145.994 32.5598 146.719 32.3467 147.293 31.9206C147.866 31.5001 148.153 30.8069 148.153 29.841V27.3609H148C147.841 27.6791 147.608 28.0058 147.301 28.341C147 28.6763 146.599 28.9575 146.099 29.1848C145.605 29.4121 144.983 29.5257 144.233 29.5257C143.227 29.5257 142.315 29.2899 141.497 28.8183C140.685 28.341 140.037 27.6308 139.554 26.6876C139.077 25.7388 138.838 24.5513 138.838 23.1251C138.838 21.6876 139.077 20.4746 139.554 19.4859C140.037 18.4916 140.688 17.7388 141.506 17.2274C142.324 16.7104 143.236 16.4518 144.241 16.4518C145.009 16.4518 145.639 16.5825 146.134 16.8439C146.634 17.0996 147.031 17.4092 147.327 17.7729C147.622 18.1308 147.847 18.4689 148 18.7871H148.17V16.6223H151.213V29.9263C151.213 31.0456 150.946 31.9717 150.412 32.7047C149.878 33.4376 149.148 33.9859 148.222 34.3496C147.295 34.7132 146.244 34.895 145.068 34.895ZM145.094 27.1052C145.747 27.1052 146.304 26.9462 146.764 26.628C147.224 26.3098 147.574 25.8524 147.813 25.2558C148.051 24.6592 148.17 23.9433 148.17 23.1081C148.17 22.2842 148.051 21.5626 147.813 20.9433C147.58 20.324 147.233 19.8439 146.773 19.503C146.318 19.1564 145.759 18.9831 145.094 18.9831C144.406 18.9831 143.832 19.1621 143.372 19.52C142.912 19.878 142.565 20.3694 142.332 20.9944C142.099 21.6138 141.983 22.3183 141.983 23.1081C141.983 23.9092 142.099 24.6109 142.332 25.2132C142.571 25.8098 142.92 26.2757 143.381 26.6109C143.847 26.9405 144.418 27.1052 145.094 27.1052ZM160.085 29.9689C158.807 29.9689 157.699 29.6876 156.761 29.1251C155.824 28.5626 155.097 27.7757 154.58 26.7643C154.068 25.753 153.813 24.5712 153.813 23.2189C153.813 21.8666 154.068 20.6819 154.58 19.6649C155.097 18.6479 155.824 17.8581 156.761 17.2956C157.699 16.7331 158.807 16.4518 160.085 16.4518C161.364 16.4518 162.472 16.7331 163.409 17.2956C164.347 17.8581 165.071 18.6479 165.582 19.6649C166.099 20.6819 166.358 21.8666 166.358 23.2189C166.358 24.5712 166.099 25.753 165.582 26.7643C165.071 27.7757 164.347 28.5626 163.409 29.1251C162.472 29.6876 161.364 29.9689 160.085 29.9689ZM160.102 27.4973C160.795 27.4973 161.375 27.3069 161.841 26.9263C162.307 26.5399 162.653 26.0229 162.881 25.3751C163.114 24.7274 163.23 24.0058 163.23 23.2104C163.23 22.4092 163.114 21.6848 162.881 21.0371C162.653 20.3837 162.307 19.8638 161.841 19.4774C161.375 19.091 160.795 18.8979 160.102 18.8979C159.392 18.8979 158.801 19.091 158.33 19.4774C157.864 19.8638 157.514 20.3837 157.281 21.0371C157.054 21.6848 156.94 22.4092 156.94 23.2104C156.94 24.0058 157.054 24.7274 157.281 25.3751C157.514 26.0229 157.864 26.5399 158.33 26.9263C158.801 27.3069 159.392 27.4973 160.102 27.4973Z"
        fill="var(--primary-color)"
      />
    </svg>
  </Link>
);
export const SearchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.58366 17.4998C13.9559 17.4998 17.5003 13.9554 17.5003 9.58317C17.5003 5.21092 13.9559 1.6665 9.58366 1.6665C5.21141 1.6665 1.66699 5.21092 1.66699 9.58317C1.66699 13.9554 5.21141 17.4998 9.58366 17.4998Z"
      stroke="#A4A7B0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3337 18.3332L16.667 16.6665"
      stroke="#A4A7B0"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Define the data structure type
export interface RealEstateData {
  [category: string]: {
    [type: string]: string[];
  };
}

export function transformPriceRanges(
  priceRanges: string[],
  type: "min" | "max"
): string[] {
  if (!Array.isArray(priceRanges) || priceRanges.length === 0) {
    throw new Error("Invalid price range array");
  }
  const transformedRanges = [...priceRanges]; // Clone the array to avoid mutation
  transformedRanges[0] = type === "min" ? "No Min" : "No Max";
  return transformedRanges;
}

export const propertyTypes = ["For sale", "For rent", "Short let"];

// Example Usage
export const salePriceRanges: string[] = [
  "No Min", // Placeholder, will be replaced
  "₦250,000",
  "₦500,000",
  "₦750,000",
  "₦1 Million",
  "₦2 Million",
  "₦5 Million",
  "₦10 Million",
  "₦20 Million",
  "₦30 Million",
  "₦40 Million",
  "₦60 Million",
  "₦80 Million",
  "₦100 Million",
  "₦150 Million",
  "₦200 Million",
  "₦250 Million",
  "₦300 Million",
  "₦400 Million",
  "₦500 Million",
  "₦600 Million",
  "₦700 Million",
  "₦800 Million",
  "₦900 Million",
  "₦1 Billion",
  "₦2 Billion",
  "₦5 Billion",
  "₦10 Billion",
  "₦20 Billion",
  "₦30 Billion",
  "₦40 Billion",
  "₦50 Billion",
];

export const parsePrice = (price: string): number | null => {
  const cleaned = price.replace(/[₦,]/g, "").trim().toLowerCase();

  if (cleaned.includes("million")) {
    const num = parseFloat(cleaned.replace("million", ""));
    return num * 1_000_000;
  } else if (cleaned.includes("billion")) {
    const num = parseFloat(cleaned.replace("billion", ""));
    return num * 1_000_000_000;
  } else {
    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }
};

export const rentPriceRanges: string[] = [
  "No Min", // Placeholder, will be replaced
  "₦100,000",
  "₦200,000",
  "₦300,000",
  "₦400,000",
  "₦500,000",
  "₦600,000",
  "₦700,000",
  "₦800,000",
  "₦900,000",
  "₦1 Million",
  "₦2 Million",
  "₦3 Million",
  "₦5 Million",
  "₦10 Million",
  "₦20 Million",
  "₦40 Million",
  "₦60 Million",
  "₦80 Million",
  "₦100 Million",
  "₦150 Million",
];

const shortletPriceRanges: string[] = [
  "No Min", // Placeholder, will be replaced
  "₦3,000",
  "₦5,000",
  "₦10,000",
  "₦20,000",
  "₦30,000",
  "₦40,000",
  "₦50,000",
  "₦100,000",
  "₦150,000",
  "₦200,000",
  "₦250,000",
  "₦300,000",
  "₦350,000",
  "₦400,000",
  "₦450,000",
  "₦500,000",
  "₦1 Million",
];

export const getPriceRanges = (
  propertyType: PropertySearchData["propertyType"]
) => {
  switch (propertyType) {
    case "For sale":
      return {
        minPrices: transformPriceRanges(salePriceRanges, "min"),
        maxPrices: transformPriceRanges(salePriceRanges, "max"),
      };
    case "For rent":
      return {
        minPrices: transformPriceRanges(rentPriceRanges, "min"),
        maxPrices: transformPriceRanges(rentPriceRanges, "max"),
      };
    case "For shortlet":
      return {
        minPrices: transformPriceRanges(shortletPriceRanges, "min"),
        maxPrices: transformPriceRanges(shortletPriceRanges, "max"),
      };
    default:
      return { minPrices: [], maxPrices: [] };
  }
};

// Property data
export const propertyData: RealEstateData = {
  Residential: {
    House: [
      "detached bungalow",
      "semi-detached bungalow",
      "terrace bungalow",
      "detached duplex",
      "semi-detached duplex",
      "terrace duplex",
      "skyscraper",
      "mansion structure",
      "high rise",
      "tube",
      "none",
    ],
    "Block of Flat": [
      "twins",
      "three",
      "four",
      "six",
      "eight",
      "semi-detached",
      "multiple",
      "detached",
      "none",
    ],
    Apartment: [
      "room & parlor",
      "single room",
      "mini flat",
      "room in flat",
      "tenement room",
      "shared house",
      "studio house",
      "none",
    ],
    Land: ["sqm", "half plot", "plot", "acre", "hectare"],
  },

  Commercial: {
    Land: [
      "joint venture",
      "agriculture land",
      "farm land",
      "industrial land",
      "factory land",
      "commercial land",
      "mass housing land",
      "estate land",
      "mixed use land",
      "none",
    ],
    "Industry & Factory": [
      "Church",
      "Industry",
      "Filling Station",
      "Hotel/Guest House",
      "Plaza",
      "Office Space",
      "Complex",
      "Mall",
      "Training Room",
      "Workshop",
      "Schools",
      "Shops",
      "Kiosk",
      "Stores",
      "Gas Plant",
      "Warehouse",
      "Gated Estate",
      "Car Wash",
      "Service Apartment",
      "House",
      "Facilities",
      "Tank Farm",
      "Production Factory",
      "Co Office",
      "Virtual Office",
      "Work Station",
      "Poultry",
      "Hospital",
      "Institution",
      "Quarry",
      "Others",
      "Lounge",
    ],
  },

  "Mixed-Use": {
    House: [
      "detached bungalow",
      "semi-detached bungalow",
      "terrace bungalow",
      "detached duplex",
      "semi-detached duplex",
      "terrace duplex",
      "skyscraper",
      "mansion structure",
      "high rise",
      "tube",
      "none",
    ],
    "Block of Flat": [
      "twins",
      "three",
      "four",
      "six",
      "eight",
      "semi-detached",
      "multiple",
      "detached",
      "none",
    ],
    Apartment: [
      "room & parlor",
      "single room",
      "mini flat",
      "room in flat",
      "tenement room",
      "shared house",
      "studio house",
      "none",
    ],
    Land: ["sqm", "half plot", "plot", "acre", "hectare"],
  },
};

export type PropertyType =
  | "For sale"
  | "For rent"
  | "For shortlet"
  | "Sale"
  | "Rent"
  | "Shortlet"
  | "";

export interface PropertySearchData {
  search: string;
  propertyType: PropertyType;
  category: string;
  min_price: string;
  max_price: string;
  unit_type: string;
  unit_sub_type: string;
  priceRange: string;
  state: string;
  local_government: string;
}

type PropertyData = {
  [category: string]: {
    [propertyType: string]: string[];
  };
};

export const mapUnitTypesToSubtypes = (
  unitTypes: string[],
  unitSubTypes: string[],
  propertyData: PropertyData
): { [key: string]: string[] } => {
  const result: { [key: string]: string[] } = {};

  unitTypes.forEach((type) => {
    const normalizedType = type.toLowerCase().replace(/\s+/g, "_");
    result[normalizedType] = [];

    Object.values(propertyData).forEach((category) => {
      Object.keys(category).forEach((propertyType) => {
        const normalizedPropertyType = propertyType
          .toLowerCase()
          .replace(/\s+/g, "_");

        if (normalizedPropertyType === normalizedType) {
          unitSubTypes.forEach((subtype) => {
            if (category[propertyType].includes(subtype)) {
              result[normalizedType].push(subtype);
            }
          });
        }
      });
    });
  });

  Object.keys(result).forEach((key) => {
    if (result[key].length === 0) {
      delete result[key];
    }
  });

  return result;
};
